import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import {
  CorrespondenceTeamDto,
  CorrespondenceActionPartyDto,
} from '@cradua/data';

@Component({
  selector: 'mrsoftapps-action-party-view',
  templateUrl: './action-party-view.component.html',
  styleUrls: ['./action-party-view.component.css'],
})
export class ActionPartyViewComponent implements OnInit {
  @Input() teams: CorrespondenceTeamDto[];
  @Input() actionParties: CorrespondenceActionPartyDto[];
  actionPartyForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<CorrespondenceActionPartyDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  selectedTeam: any;
  filteredDelete: Array<any> = [];
  loading = true;
  filteredActionParty: Array<CorrespondenceActionPartyDto> = [];
  status: boolean;
  selectedTeamId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.actionPartyForm = this.fb.group({ ActionParties: this.fb.array([]) });
  }

  // method to display countries
  setActionParty() {
    const control = this.actionPartyForm.controls.ActionParties as FormArray;
    this.filteredActionParty.forEach((e) => {
      control.push(
        this.fb.group({
          CorrespondenceActionPartyName: e.CorrespondenceActionPartyName,
          CorrespondenceTeamId: e.CorrespondenceTeamId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.actionPartyForm.controls.ActionParties as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter state
  selectActionParty(event: string) {
    this.filteredActionParty = this.actionParties.filter(
      (s) => s.CorrespondenceTeamId === event
    );
    this.selectedTeamId = event;
    const control = this.actionPartyForm.controls.ActionParties as FormArray;

    if (this.filteredActionParty.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setActionParty();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Country
  addActionParty() {
    const control = this.actionPartyForm.controls.ActionParties as FormArray;
    control.insert(
      0,
      this.fb.group({
        CorrespondenceActionPartyName: ['', Validators.required],
        CorrespondenceTeamId: this.selectedTeamId,
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteActionParty(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.actionPartyForm.controls
          .ActionParties as FormArray;
        control.removeAt(index);

        if (value.id != null && value.id !== '') {
          this.filteredDelete.push(value.id);
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'actionParty';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('actionParty');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
